import { FilterableTableInvoices } from "../../../components/TableInvoices/FilterableTableInvoices";
import { INVOICE_STATUSES_OUTSTANDING } from "../../../types";

export const RouteOutstanding: React.FC = () => (
  <FilterableTableInvoices
    statuses={INVOICE_STATUSES_OUTSTANDING}
    showDownloadCsv
    emptyState={{ standart: "No outstanding invoices." }}
  />
);
